import { useEffect, useMemo, useState } from "react";
import { useController, useFormContext } from "react-hook-form";

import { type IMedicalInput } from "../sections/MedicalSections.model";
import HistoryCell from "./HistoryCell";
import InputCell from "./InputCell";
interface Props extends IMedicalInput {
  history?: boolean;
  vaxid?: string | null;
}
const MedicalInput = ({ history, vaxid, ...props }: Props) => {
  const { control, setValue } = useFormContext();
  const { field } = useController({
    name: props.id,
    control,
    defaultValue: props.value,
    disabled: props.disabled ?? false,
  });

  const [previousValue, setPreviousValue] = useState(props.value);

  useEffect(() => {
    if (props.value !== previousValue) {
      setValue(props.id, props.value);
      setPreviousValue(props.value);
    }
  }, [props.id, props.value, setValue, previousValue]);

  const clearedProps = useMemo(() => ({ ...props, label: undefined }), [props]);

  if (history) {
    return <HistoryCell field={field} unit={props.unit} />;
  }

  return (
    <InputCell
      field={field}
      clearedProps={clearedProps}
      vaxid={vaxid}
      {...props}
      unit={props.unit}
    />
  );
};
export default MedicalInput;
